/** Shared Play-with-Host phase / game-type constants (mirror server). */
export const SW_GAME_TYPES = Object.freeze({
  USER_WHEEL: "USER_WHEEL",
  HOT_SEAT: "HOT_SEAT",
});

export const SW_PHASES = Object.freeze({
  WAITING: "WAITING",
  INTRO: "INTRO",
  GAME_ABOUT_TO_START: "GAME_ABOUT_TO_START",
  FORCE: "FORCE",
  SELECT_HOT_SEAT: "SELECT_HOT_SEAT",
  BUILDING_WHEEL: "BUILDING_WHEEL",
  WHEEL_READY: "WHEEL_READY",
  SPINNING: "SPINNING",
  RESULT: "RESULT",
  // Enhanced Hot Seat flow (BTN 1-7)
  INVITE: "INVITE",
  ANNOUNCE: "ANNOUNCE",
  HOT_SEAT_SLIDE: "HOT_SEAT_SLIDE",
  LUCKY_PLAYER: "LUCKY_PLAYER",
  BUILDING_USER_WHEEL: "BUILDING_USER_WHEEL",
  COUNTDOWN: "COUNTDOWN",
  USER_WHEEL_READY: "USER_WHEEL_READY",
});

export const SW_WHEEL_VISIBLE_PHASES = new Set([
  SW_PHASES.WHEEL_READY,
  SW_PHASES.SPINNING,
  SW_PHASES.RESULT,
  SW_PHASES.USER_WHEEL_READY,
]);

export const isWheelVisiblePhase = (phase) =>
  SW_WHEEL_VISIBLE_PHASES.has(phase);

/** Phases where the user wheel is shown (for hot seat selection) */
export const SW_USER_WHEEL_PHASES = new Set([
  SW_PHASES.USER_WHEEL_READY,
]);

export const isUserWheelPhase = (phase) =>
  SW_USER_WHEEL_PHASES.has(phase);

/** All phases in the enhanced hot seat flow */
export const SW_ENHANCED_HOT_SEAT_PHASES = new Set([
  SW_PHASES.INVITE,
  SW_PHASES.ANNOUNCE,
  SW_PHASES.HOT_SEAT_SLIDE,
  SW_PHASES.LUCKY_PLAYER,
  SW_PHASES.BUILDING_USER_WHEEL,
  SW_PHASES.COUNTDOWN,
  SW_PHASES.USER_WHEEL_READY,
]);
